import { motion } from "motion/react";

function TPGraph({ activeStep, stepId }: { activeStep: number; stepId: number }) {
  return (
    <>
      <motion.path
        d="M12 270C12 270 21 249 21 214H339"
        stroke="url(#paint_tp)"
        strokeWidth="24"
        strokeLinecap="round"
        strokeLinejoin="round"
        initial="hidden"
        variants={{
          show: {
            pathLength: [0.001, 1],
            pathOffset: [0.0001],
            opacity: 1,
            transition: { duration: 3, ease: [0.25, 0.1, 0.25, 1] },
          },
          hidden: {
            pathLength: [1, 0.001],
            pathOffset: [0.0001, 0.9999],
            opacity: 0,
            transition: { pathLength: { opacity: 0.2 } },
          },
        }}
        animate={activeStep === stepId ? "show" : "hidden"}
      />
      <defs>
        <linearGradient
          id="paint_tp"
          x1="175"
          y1="214"
          x2="175"
          y2="270"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#02C4F5" />
          <stop offset="1" stopColor="#A7EDFF" />
        </linearGradient>
      </defs>
    </>
  );
}

export default TPGraph;
